import { render } from "./RodamientoAutomotriz.vue?vue&type=template&id=b0a82788&scoped=true"
import script from "./RodamientoAutomotriz.vue?vue&type=script&lang=js"
export * from "./RodamientoAutomotriz.vue?vue&type=script&lang=js"

import "./RodamientoAutomotriz.vue?vue&type=style&index=0&id=b0a82788&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b0a82788"]])

export default __exports__